module.exports = __webpack_public_path__ + "static/hero-illustration-d91532a93e135323627730e3abf439f1.svg";